var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOwnerReporting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2.5C1.725 2.5 1.5 2.725 1.5 3V13C1.5 13.275 1.725 13.5 2 13.5H12C12.275 13.5 12.5 13.275 12.5 13V3C12.5 2.725 12.275 2.5 12 2.5H2ZM0 3C0 1.89688 0.896875 1 2 1H12C13.1031 1 14 1.89688 14 3V13C14 14.1031 13.1031 15 12 15H2C0.896875 15 0 14.1031 0 13V3ZM7 4C7.41563 4 7.75 4.33437 7.75 4.75V11.25C7.75 11.6656 7.41563 12 7 12C6.58437 12 6.25 11.6656 6.25 11.25V4.75C6.25 4.33437 6.58437 4 7 4ZM4 7C4.41563 7 4.75 7.33437 4.75 7.75V11.25C4.75 11.6656 4.41563 12 4 12C3.58437 12 3.25 11.6656 3.25 11.25V7.75C3.25 7.33437 3.58437 7 4 7ZM9.25 9.75C9.25 9.33438 9.58438 9 10 9C10.4156 9 10.75 9.33438 10.75 9.75V11.25C10.75 11.6656 10.4156 12 10 12C9.58438 12 9.25 11.6656 9.25 11.25V9.75Z",
    fill: "#B88333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnerReporting);
export default __webpack_public_path__ + "static/media/owner-reporting.949ead0be4da8e20526b76bcc5c6c0fa.svg";
export { ForwardRef as ReactComponent };